import { darken } from 'polished';
import styled, { css } from 'styled-components';
import { Colors } from '.';
import { Copy, Title } from '../app/dashboard/elements/LayoutElements';

const Top = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    * > {
        flex: 1 1 auto;
    }
`;

const Icon = styled.div<{ color: string }>`
    flex: 0 0 auto;
    margin-right: 0.625rem;
    color: ${p => p.color};
`;

const Base = styled.div<{ active?: boolean, disabled?: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 1rem 1.25rem;    
    border: solid 0.0675rem #eeeeee;
    border-radius: 0.25rem;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
    cursor: pointer;
    user-select: none;

    background: #fff;
    &:hover { background: ${darken(0.025, '#fff')} }
    &:active { background: ${darken(0.05, '#fff')} }

    ${Copy} {
        margin: 0;
        margin-top: 0.625rem;
        font-size: .875rem;
        color: ${Colors.textLight};
    }
    ${Title} {
        margin: 0;
        font-size: 1rem;
        color: ${Colors.text};
    }

    ${p => p.active && css`
        border-color: ${Colors.primary};
        box-shadow: 0 0 0 0.0675rem ${Colors.primary};
        pointer-events: none;
    `}

    ${p => p.disabled && css`
        pointer-events: none;
        opacity: 0.5;
        filter: grayscale(50%);
    `}
`;

export const GridButton = Object.assign(Base, { Top, Icon });
